import { ReceptionListDispInfoBase } from "../base";
import { ReceptionDeliveryKind } from "../items";

// 依頼一覧画面表示用model
export class ReceptionListDispInfo extends ReceptionListDispInfoBase {
  constructor() {
    super();
    this.deliveryKindList = [];
  }

  // 交付方法リスト
  public deliveryKindList: ReceptionDeliveryKind[];
}
